import { useMemo } from "react";
import {
  createPermissionEvaluator,
  useAuthStore,
  type PermissionEvaluator,
} from "@nasam/kernel";

const NO_PERMISSIONS: readonly string[] = [];

/**
 * The session user's permission evaluator — `canView`/`canCreate`/`canUpdate`/
 * `canDelete` for a given `<module>.<submodule>.<screen>` prefix. Use this to
 * gate action buttons and other in-page affordances; nav visibility already
 * goes through `resolveFeatureNavigation` and route access through
 * `requirePermission`, both built on the same evaluator.
 */
export function usePermissions(): PermissionEvaluator {
  const grants = useAuthStore((state) => state.user?.permissions ?? NO_PERMISSIONS);
  return useMemo(() => createPermissionEvaluator(grants), [grants]);
}
